import { createFileRoute } from "@tanstack/react-router";
import { faqJsonLd, jsonLdScript, pageHead } from "@/components/site/seo-copy";
import SalesTrainingView from "@/components/cl/views/SalesTrainingView";

const faqs = [
  {
    q: "Is the training online or in person?",
    a: "All our training is live online, so your team can join from anywhere. We also join your team on real conversations.",
  },
  {
    q: "Is it tailored to our product?",
    a: "Always. We learn your product, pricing and buyers first, then build every session around them.",
  },
  {
    q: "How big a team can you train?",
    a: "From three reps to a full department. We shape the format to fit.",
  },
  {
    q: "What happens after the training?",
    a: "We keep coaching and reviewing calls so the lessons stick.",
  },
];

export const Route = createFileRoute("/sales-training")({
  head: () => ({
    ...pageHead("/sales-training"),
    scripts: [jsonLdScript(faqJsonLd(faqs))],
  }),
  component: SalesTrainingView,
});
